import { requestGet } from '@/utils/request';

const api = {
    LIST: '/finance/user_stat_list',
};

export async function userStatList(queryParams) {
    return requestGet(api.LIST, queryParams);
}